import { render, staticRenderFns } from "./GoodsRecommend.vue?vue&type=template&id=a409755e&scoped=true"
import script from "./GoodsRecommend.vue?vue&type=script&lang=js"
export * from "./GoodsRecommend.vue?vue&type=script&lang=js"
import style0 from "./GoodsRecommend.vue?vue&type=style&index=0&id=a409755e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a409755e",
  null
  
)

export default component.exports